import { render, staticRenderFns } from "./HistorySidePanel.vue?vue&type=template&id=23416b06&scoped=true&"
import script from "./HistorySidePanel.vue?vue&type=script&lang=ts&"
export * from "./HistorySidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23416b06",
  null
  
)

export default component.exports